<template>
    <div id="adjustmentSearch">
        <a-modal
                title="Adjust Menu"
                :visible="visible"
                width="85%"
                @cancel="handleCancelTable"
        >
            <template slot="footer">
                          <a-button type="primary" @click="AdjustTableSelect" size="small">{{ $t('publicLang.Save') }}</a-button>
            </template>
           <a-row>
                <a-row >
                    <a-row type="flex" justify="space-between">
                        <a-col></a-col>
                        <a-col>
                            <div style="display: flex;justify-content: center">
                                <a-pagination
                                        size="small"
                                        :total="page.pagingTotal"
                                        v-model="page.currentVal"
                                        :pageSize.sync="page.pagingSize"
                                        @change="tableChangePage"
                                        @showSizeChange="onShowSizeChange"
                                        showSizeChanger

                                />
                                <a-dropdown>
                                    <span class="sbxs">
                                        <img class="sbxs" src="../../../../assets/img/ss-more.png"  width="22" height="22">
                                    </span>
                                    <a-menu slot="overlay">
                                        <a-menu-item style="font-size: 12px" @click="AdvanceSearch">
                                            <a-icon type="zoom-in" /> {{ $t('pubGicSet.AdvanceSearch') }}
                                        </a-menu-item>
                                    </a-menu>
                                </a-dropdown>
                            </div>
                        </a-col>
                    </a-row>
                    <a-row style="margin-top: 4px;text-align: center" >
                        <a-spin :spinning="adjustLoading">
                            <vxe-table
                                    ref="adjustTable"
                                    stripe
                                    highlight-current-row
                                    @checkbox-change="selectChangeEvent"
                                    @checkbox-all="selectChangeEvent"
                                    border
                                    resizable
                                    size="mini"
                                    :data.sync="tableData"
                                    :loading="adjustLoading"
                                    max-height="350"
                                    :radio-config="{labelField: 'name', trigger: 'row'}"
                                    v-if="cols.length > 0"
                            >
                                <template v-slot:empty>
                                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                                </template>
                                <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                                <template v-for="(item) in cols">
                                    <vxe-table-column show-header-overflow show-overflow  :width="item.proWidth == null ? '200' : item.proWidth" :key="item.uid">
                                        <template v-slot:header="{ column }">
                                            <a-tooltip placement="topLeft">
                                                <template slot="title">
                                                    <span>{{item.description == null ? "-" : item.description}}</span>
                                                </template>
                                                <span> {{ item.title }}</span>
                                            </a-tooltip>
                                        </template>
                                        <template v-slot="{ row }">
                                            <a-tooltip placement="topLeft">
                                                <template slot="title">
                                                    <span>{{row[item.label].value == null ? "-" : row[item.label].value}}</span>
                                                </template>
                                                <span style="fontSize: 12px;height: 30px;line-height: 30px;display: block;">{{row[item.label].value == null ? "-" : row[item.label].value}}</span>
                                            </a-tooltip>
                                        </template>
                                    </vxe-table-column>
                                </template>
                            </vxe-table>
                        </a-spin>
                    </a-row>
                </a-row>
                <a-divider dashed style="margin: 4px 0"/>
            </a-row>


            <a-modal
                    :title="$t('pubGicSet.AdvanceSearch')"
                    :visible="AdjustAdvanVis"
                    @cancel="handleAdjustAdvan"
                    width="85%">
                <template slot="footer">
                    <a-button type="primary" @click="adjustAdvanSearch" size="small">{{ $t('pubGicSet.Search') }}</a-button>
                </template>
                <and-or :options="options" :isFirst="isFirst" ref="adjustAndor" style="margin-bottom: 10px;"></and-or>
            </a-modal>
        </a-modal>
        <!--advanSearch -->

        <!-- <move-split ref="moveSplit" v-on:splitMove="getSplitMove"></move-split> -->
    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    import andOr from "../../../com/queryBuilder/components/AndOR.vue";
    import cookie from '../../../../api/cookie';
    import { mapState } from "vuex";

    export default{
        components:{
            andOr
            // moveSplit,
        },
        props:{
            waseCode:{
                type: String,
                default: function() {
                    return '';
                }
            },
            ajtype:{
                type: String,
                default: function() {
                    return '';
                }
            },
            adjustParHeaderId: {
                type: String,
                default: function() {
                    return '';
                }
            },
            searTableUid: {
                type: String,
                default: function() {
                    return '';
                }
            },
        },
        data(){
            return{
                transFerView: true,
                ifEditTransfer: true,
                page:{
                    pagingTotal: 0,
                    currentVal: 1,
                    pagingSize: 30
                }, // 分页
                radioRows: [], // advan serach 后 table 选中的信息
                tableData: [], // serach table data
                cols: [],  // serach table cloumns
                visible: false,
                AdjustAdvanVis: false,
                isFirst: true,
                options: {
                    condition: [],
                    fieldNameSel: []
                },
                adjustLoading: false,
                moveTransferTable: [],
                moveCompleteData: [],
//                tranferName
                transferFieldname: undefined,
                transferFieldnameSelect: [],
                traneferFieldnameTable: [],
//                putaway 查询条件
                putawayInfo: {},
                editTransfer: {},
                batchNo: 0
            }
        },
        computed: {
            ...mapState(["lang"]),
        },
        methods:{
            getAvQty(){
                for (let i = 0; i < this.cols.length; i++) {
                    if(this.cols[i].title == 'AV MOVE QTY'){
                        return this.cols[i].label;
                    }
                }
                return null;
            },
            getToLocation(){
                for (let i = 0; i < this.cols.length; i++) {
                    if(this.cols[i].title == 'LOCATION CODE'){
                        return this.cols[i].label;
                    }
                }
                return null;
            },
            ainputNumchange(val){
                this.$nextTick(()=>{
                    this.$refs.adjustTable.setCheckboxRow([val],true)
                    this.radioRows = this.$refs.adjustTable.getCheckboxRecords()
                })
            },
            moveSplit(){
                ajax.get(api.INVENTORYMOVESPLIT,{uid: this.radioRows[0].uid}).then(res=>{
                    if(res.code == 200){
                        let tt = {
                            headerUid: this.adjustParHeaderId,
                            userSqlDto:this.$refs.adjustAndor.queryFormStatus(),
                            invVos: res.data,
                            markStr: this.ajtype,
                            waseCode: this.waseCode
                        }
                        this.$refs.moveSplit.show(tt)
                    }else{
                        this.$customMessage.error(this.$t('pubGicSet.NotAllowToSplit'));
                        return
                    }
                })

            },
            addtransferName(){
                if(this.transferFieldname == undefined){
                    this.$customMessage.error(this.$t('pubGicSet.PleaseSelectFieldName'));
                    return
                }
                if(this.traneferFieldnameTable.length > 0){
                    for(let ii in this.traneferFieldnameTable){
                        if(this.traneferFieldnameTable[ii].fieldname == this.transferFieldname){
                            this.$customMessage.error(this.$t('pubGicSet.FieldAddedRepeatedly'));
                            return
                        }
                    }
                }
                this.traneferFieldnameTable.push({fieldname: this.transferFieldname,toValue: ''})
            },
            deleteTransferName(){
                let selectData = this.$refs.transferFilednameTable.getCheckboxRecords();

                for(let ii in this.traneferFieldnameTable){
                    for(let jj in selectData){
                        if(this.traneferFieldnameTable[ii].fieldname == selectData[jj].fieldname){
                            this.traneferFieldnameTable.splice(ii,1);
                        }
                    }
                }

                this.$refs.transferFilednameTable.removeCheckboxRow();
            },
            searchMovehandleSearch(val){
                if(val.length < 4){
                    return
                }
                let params = {
                    whsCode: this.waseCode,
                    keyword: val,
                }
                ajax.post(api.INVENTORYLOCATION,params).then(res=>{
                    this.moveCompleteData = res.data
                })
            },
            onShowSizeChange(page,pageSize){
                this.page.currentVal = 1
                this.page.pagingSize = pageSize
                this.adjustAdvanSearch()
            },
            tableChangePage(current){
                this.page.currentVal = current
                this.adjustAdvanSearch()
            },
            show(type,obj,batchNo){
                this.batchNo = batchNo;
                this.editTransfer = obj
                this.visible = true
                this.AdjustAdvanVis = true
                this.$nextTick(()=>{
                    this.$refs.adjustAndor.fillFormStatus(null);
                })
                this.init(type)
            },
            handleCancelTable(){
                this.visible = false
                this.transferFieldname = undefined
                this.traneferFieldnameTable = []
            },
            handleAdjustAdvan(){
                this.AdjustAdvanVis = false
            },
            AdvanceSearch(){
                this.AdjustAdvanVis = true
            },
//            初始化数据
            init(type){
          
                if(type == 'T'){
                    this.$nextTick(()=>{
                        this.ifEditTransfer = false
                        this.adjustAdvanSearch()
                    })
                }
                if(type == 'view'){
                    this.$nextTick(()=>{
                        this.ifEditTransfer = false
                        this.adjustAdvanSearch()
                        let arr = []
                        for(let i in this.editTransfer){
                            arr.push({fieldname:this.editTransfer[i].key,toValue: this.editTransfer[i].value})
                        }
                        this.traneferFieldnameTable = arr
                        // this.transFerView = false
                    })
                }
                // else{
                //      this.transFerView = true;
                // }
                this.ifEditTransfer = true
                ajax.get(api.GETSQLDROPDATA).then(res => {
                    this.options.condition = res.data.condition;
                });
                let params = {
                    gmcUid: this.searTableUid
                };
                ajax.post(api.GETFIELDNAMEDROPDATA, params).then(res => {
                    let data = res.data
                    let type = '='
                    if(this.ajtype == 'invMoveDetail'){
                        type = '<>'
                    }
                    this.putawayInfo = {
                        'condition': 'AND',
                        rules: []
                    }
                    for(let i in data){
                        if(data[i].fieldName == "LOCATION TYPE"){
                            this.putawayInfo.rules.push({
                                boolValue: false,
                                flName: data[i].detailUid,
                                flType: "String",
                                numVal: "",
                                operator: type,
                                textSearchval: "Staging@##@",
                                timeValue: ''
                            })
                        }
                        if(data[i].fieldName == "WAREHOUSE CODE" ){
                            this.putawayInfo.rules.push({
                                boolValue: false,
                                flName: data[i].detailUid,
                                flType: "String",
                                numVal: "",
                                operator:'=',
                                textSearchval: this.waseCode +"@##@",
                                timeValue: ''
                            })
                        }
                    }
                    this.options.fieldNameSel = data
                });



                this.traneferFieldnameTable = []
             this.transferFieldname = undefined

                this.tableData = []
                this.cols = []
                if(this.ajtype == 'transferDetail'){
                    ajax.get(api.INVENTORYFIELDNAME).then(res=>{
                        this.transferFieldnameSelect = res.data.fieldNames
                    })
                }
                this.AdjustAdvanVis = true
            },
//            search 搜索后的table
            adjustAdvanSearch(){
                this.adjustLoading = true
                let searcQuery= this.$refs.adjustAndor.queryFormStatus()
                console.info(searcQuery)
                if(this.ajtype == 'puatWay' || this.ajtype == 'invMoveDetail'){
                    searcQuery.rules.push(this.putawayInfo)
                }
                let params = {
                    gmcUid: this.searTableUid,
                    language: this.lang,
                    userSqlDto: searcQuery,
                    paging: {
                        pageNum: this.page.currentVal,
                        pageSize: this.page.pagingSize
                    }
                };
                this.AdjustAdvanVis = false
                this.visible = true
                console.info(params)
                ajax.post(api.SKUS, params).then(res=>{
                    if(res.code == 200){
                        this.adjustLoading = false
                        this.cols = res.data.tableList.columns
                        let arryNew = res.data.tableList.data;
                     
                        if(this.ajtype == 'Transfer' || this.ajtype == 'transferDetail'){
                             
                        for (let i = 0; i < arryNew.length; i++) {
                            
                            arryNew[i].qty = this.getAvQty() == null ? 1 : arryNew[i][this.getAvQty()].value
                            arryNew[i].toLocation = this.getToLocation() == null ? '' : arryNew[i][this.getToLocation()].value
                            this.tableData.push(arryNew[i])
                        }
                        }else{
                            this.tableData = arryNew;
                        }
                        this.page.pagingTotal =res.data.tableList.paging.totalPageSize
                    }
                })
            },
//            table 选中 提交ajax aj move
            AdjustTableSelect(){
                let arr =[]
                this.radioRows = this.$refs.adjustTable.getCheckboxRecords()
                if(this.radioRows.length > 0){
                    for(let i in this.radioRows){
                            arr.push({uid: this.radioRows[i].uid})
                    }
                }else{
                    this.$customMessage.error(this.$t('publicLang.PleaseSltAtleast'));
                    return
                }

                let params = {
                    headerUid: this.adjustParHeaderId,
                    userSqlDto:this.$refs.adjustAndor.queryFormStatus(),
                    invVos: arr,
                    markStr :'invAdjDetail'
                }

                ajax.post(api.INVDETAILPUB,params).then(res=>{
                    if(res.code == 200){


                    ajax.get(api.INVENTORYINVADJUETMENTHEADER,{'uid' : this.adjustParHeaderId }).then(res=>{
                        if(res.code == 200){
                            console.info(res)
                           let tabList = res.data.invAdjDetailDtos;                                           
                       
                            //  this.wareHourseDis = true
                             this.$emit('getAdjustData', tabList)
                             this.visible = false
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                           
                        // if(this.ajtype == 'invAdjDetail'){
                        //     ajax.get(api.INVENTORYINVADJUETMENT,{uid: this.adjustParHeaderId}).then(res=>{
                            
                        //     })
                        // }
                        // this.visible = false
                        // this.radioRows = []
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                })
            },
            transFerTableSelect(){
                //遍历FieldName查看value是否为空
                for(let ii in this.traneferFieldnameTable) {
                    let toValue = this.traneferFieldnameTable[ii].toValue;
                    if (toValue == null || toValue=="") {
                        this.$customMessage.error(this.$t('pubGicSet.ToValueCannotBeEmpty'));
                        return;
                    }
                }


                //                编辑新增

                if(this.ifEditTransfer){
                    this.radioRows = this.$refs.adjustTable.getCheckboxRecords();
                    if(this.radioRows.length> 0){
                        let params = {
                            headerUid: this.adjustParHeaderId,
                            userSqlDto:this.$refs.adjustAndor.queryFormStatus(),
                        }
                        let invVos = []
                        let keyValueKit = []
                        for(let i in this.radioRows){
                            if(this.radioRows[i].qty == undefined || this.radioRows[i].qty == '' || this.radioRows[i].toLocation == undefined || this.radioRows[i].toLocation == ''){
                                this.$customMessage.error(this.$t('pubGicSet.qtyTolocatioRequired'));
                                return
                            }else{
                                invVos.push({
                                    qty: this.radioRows[i].qty,
                                    toLocation: this.radioRows[i].toLocation,
                                    uid: this.radioRows[i].uid
                                })
                            }
                        }
                        for(let ii in this.traneferFieldnameTable){
                            keyValueKit.push({key: this.traneferFieldnameTable[ii].fieldname, value: this.traneferFieldnameTable[ii].toValue})
                        }
                        params.keyValueKit = keyValueKit
                        params.invVos = invVos
                        ajax.post(api.INVTRANSFERDETAIL,params).then(res=>{
                            if(res.code == 200){
                                this.visible = false
                                ajax.get(api.INVENTORYINVTRANSFER,{uid: this.adjustParHeaderId}).then(res=>{
                                    this.$emit('getAdjustData', res.data)
                                })
                            }else{
                                this.$customMessage.error(res.msg);
                            }
                        })
                    }else{
                        this.$customMessage.error(this.$t('pubGicSet.PleaseCheckTheData'));
                        return
                    }
                }else{
                    let keyValueKit = []
                    for(let ii in this.traneferFieldnameTable){
                        keyValueKit.push({key: this.traneferFieldnameTable[ii].fieldname, value: this.traneferFieldnameTable[ii].toValue})
                    }
                    let params = {
                       headerUid: this.adjustParHeaderId,
                        keyValueKit: keyValueKit,
                        batchNo: this.batchNo
                    }
                    ajax.post(api.INVENTORYINVSAVEUDF,params).then(res=>{
                        if(res.code == 200){
                            this.visible = false
                            ajax.get(api.INVENTORYINVTRANSFER,{uid: this.adjustParHeaderId}).then(res=>{
                                this.$emit('getAdjustData', res.data)
                            })
                        }else{
                            this.$customMessage.error(res.msg);
                        }
                    })
                }




            },
//            table 选中 应该没什么用咯
            selectChangeEvent({selection}){
                this.radioRows = selection
            },
            getSplitMove(val){
                this.visible = false
                this.$emit('getAdjustData',val)
            }
        }
    }
</script>